(function () {
  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { observer.observe(el); });
  }

  function initContadores() {
    var els = document.querySelectorAll('[data-mt-contador]');
    if (!els.length) return;
    var animated = new WeakSet();
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !animated.has(entry.target)) {
          animated.add(entry.target);
          var el = entry.target;
          var end = parseFloat(el.getAttribute('data-mt-contador'));
          var suffix = el.getAttribute('data-mt-sufijo') || '';
          var dur = 1400;
          var start = null;
          function step(ts) {
            if (!start) start = ts;
            var progress = Math.min((ts - start) / dur, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            el.textContent = Math.round(end * eased) + suffix;
            if (progress < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { observer.observe(el); });
  }

  function initComparador() {
    var wraps = document.querySelectorAll('[data-mt-comparador]');
    wraps.forEach(function (wrap) {
      var handle = wrap.querySelector('.mt-comparador-manija');
      var after = wrap.querySelector('.mt-comparador-despues');
      if (!handle || !after) return;
      var dragging = false;

      function setPos(clientX) {
        var rect = wrap.getBoundingClientRect();
        var pct = ((clientX - rect.left) / rect.width) * 100;
        pct = Math.max(0, Math.min(100, pct));
        after.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
        handle.style.left = pct + '%';
      }

      handle.addEventListener('pointerdown', function (e) {
        dragging = true;
        handle.setPointerCapture(e.pointerId);
      });
      window.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        setPos(e.clientX);
      });
      window.addEventListener('pointerup', function () { dragging = false; });
      wrap.addEventListener('click', function (e) {
        if (e.target === handle) return;
        setPos(e.clientX);
      });
    });
  }

  function initGaleriaProducto() {
    var galerias = document.querySelectorAll('[data-mt-galeria]');
    galerias.forEach(function (galeria) {
      var principal = galeria.querySelector('[data-mt-galeria-principal]');
      var minis = galeria.querySelectorAll('[data-mt-galeria-mini]');
      if (!principal || !minis.length) return;
      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var full = mini.getAttribute('data-full');
          if (!full) return;
          principal.src = full;
          minis.forEach(function (m) { m.classList.remove('mt-activa'); });
          mini.classList.add('mt-activa');
        });
      });
    });
  }

  function initVariantes() {
    var forms = document.querySelectorAll('[data-mt-producto-form]');
    forms.forEach(function (form) {
      var dataEl = form.querySelector('[data-mt-variantes-json]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var selects = form.querySelectorAll('[data-mt-opcion]');
      var idInput = form.querySelector('input[name="id"]');
      var precioEl = form.querySelector('[data-mt-precio]');
      var compareEl = form.querySelector('[data-mt-precio-comparado]');
      var addBtn = form.querySelector('[data-mt-add]');

      function fmt(cents) {
        return (cents / 100).toLocaleString(document.documentElement.lang || 'es', {
          style: 'currency',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
        });
      }

      function currentSelection() {
        return Array.prototype.map.call(selects, function (s) { return s.value; });
      }

      function findVariant() {
        var sel = currentSelection();
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === sel[i]; });
        });
      }

      function update() {
        var variant = findVariant();
        if (!variant) return;
        idInput.value = variant.id;
        if (precioEl) precioEl.textContent = fmt(variant.price);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = fmt(variant.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (addBtn) {
          if (variant.available) {
            addBtn.disabled = false;
            addBtn.textContent = addBtn.getAttribute('data-texto-disponible');
          } else {
            addBtn.disabled = true;
            addBtn.textContent = addBtn.getAttribute('data-texto-agotado');
          }
        }
      }

      selects.forEach(function (s) { s.addEventListener('change', update); });
      if (selects.length) update();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initContadores();
    initComparador();
    initGaleriaProducto();
    initVariantes();
  });
})();
